import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API } from "@/services/api";

export function useCrmData() {
  const empty = { dashboard: null, patients: [], appointments: [], leads: [], workflows: [], treatments: [], integrations: [], staff: [], audit: [], reports: null };
  const query = useQuery({
    queryKey: ["doctor-mo-crm-data"],
    queryFn: async () => {
      const keys = ["dashboard", "patients", "appointments", "leads", "workflows", "treatment-templates", "integrations", "staff", "audit-logs", "reports"];
      const res = await Promise.all(keys.map((k) => axios.get(`${API}/${k}`).catch((error) => ({ data: k === "dashboard" || k === "reports" ? null : [], error }))));
      return { dashboard: res[0].data, patients: res[1].data, appointments: res[2].data, leads: res[3].data, workflows: res[4].data, treatments: res[5].data, integrations: res[6].data, staff: res[7].data, audit: res[8].data, reports: res[9].data };
    },
  });
  return { data: query.data || empty, loading: query.isLoading, refresh: query.refetch };
}
